// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_Footer__QazpK {
  font-family: "Roboto";
}
.Footer_Footer__QazpK .Footer_content__eSS1G {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  margin: 30px auto;
  border-bottom: 2px solid rgba(217, 217, 217, 0.45);
  flex-wrap: wrap;
}
@media (max-width: 1386px) {
  .Footer_Footer__QazpK .Footer_content__eSS1G {
    width: 95%;
  }
}
@media (max-width: 920px) {
  .Footer_Footer__QazpK .Footer_content__eSS1G {
    margin: 15px auto;
  }
}
@media (max-width: 780px) {
  .Footer_Footer__QazpK .Footer_content__eSS1G {
    flex-direction: column-reverse;
  }
}
@media (max-width: 790px) {
  .Footer_Footer__QazpK .Footer_content__eSS1G div {
    width: 100%;
    text-align: center;
  }
}
.Footer_Footer__QazpK .Footer_content__eSS1G .Footer_links__MvOVh {
  display: flex;
}
.Footer_Footer__QazpK .Footer_content__eSS1G .Footer_links__MvOVh ul {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
}
.Footer_Footer__QazpK .Footer_content__eSS1G ul {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
}
.Footer_Footer__QazpK .Footer_content__eSS1G ul li {
  padding: 4px;
  display: flex;
}
.Footer_Footer__QazpK .Footer_content__eSS1G ul li svg {
  margin-right: 10px;
  width: 23px;
}
.Footer_Footer__QazpK .Footer_content__eSS1G ul a {
  color: rgba(255, 255, 255, 0.63);
  font-size: 18px;
}
@media (max-width: 640px) {
  .Footer_Footer__QazpK .Footer_content__eSS1G ul a {
    font-size: 15px;
  }
}
.Footer_Footer__QazpK .Footer_c_right__OrmYR {
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  flex-wrap: wrap;
}
@media (max-width: 1386px) {
  .Footer_Footer__QazpK .Footer_c_right__OrmYR {
    width: 95%;
  }
}
@media (max-width: 920px) {
  .Footer_Footer__QazpK .Footer_c_right__OrmYR {
    flex-direction: column-reverse;
    margin-bottom: 5px;
  }
}
@media (max-width: 640px) {
  .Footer_Footer__QazpK .Footer_c_right__OrmYR {
    justify-content: center;
  }
}
.Footer_Footer__QazpK .Footer_c_right__OrmYR div {
  display: flex;
}
.Footer_Footer__QazpK .Footer_c_right__OrmYR div a {
  color: rgba(255, 255, 255, 0.63);
  font-family: "hemi_head";
}
@media (max-width: 640px) {
  .Footer_Footer__QazpK .Footer_c_right__OrmYR div a {
    font-size: 14px;
  }
}
@media (max-width: 368px) {
  .Footer_Footer__QazpK .Footer_c_right__OrmYR div a {
    font-size: 12px;
  }
}
.Footer_Footer__QazpK .Footer_c_right__OrmYR div a svg {
  vertical-align: bottom;
}
.Footer_Footer__QazpK .Footer_c_right__OrmYR div li {
  padding: 0 7px;
  color: rgba(255, 255, 255, 0.63);
  list-style: none;
}
@media (max-width: 640px) {
  .Footer_Footer__QazpK .Footer_c_right__OrmYR div li {
    font-size: 14px;
    padding: 0 5px;
  }
}
.Footer_Footer__QazpK .Footer_c_right__OrmYR .Footer_media__-4Q9J {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}
@media (max-width: 920px) {
  .Footer_Footer__QazpK .Footer_c_right__OrmYR .Footer_media__-4Q9J {
    margin-bottom: 7px;
    order: 1;
  }
}
.Footer_Footer__QazpK .Footer_c_right__OrmYR .Footer_media__-4Q9J img {
  width: 40px;
  margin-left: 5px;
}
.Footer_Footer__QazpK .Footer_c_right__OrmYR .Footer_media__-4Q9J a {
  color: rgba(255, 255, 255, 0.63);
  font-family: "hemi_head";
  display: flex;
  align-items: center;
}
.Footer_Footer__QazpK .Footer_media1__v5PH0 {
  display: flex;
  list-style: none;
  justify-content: center;
  align-items: end;
  margin: 0;
  padding: 0;
}
@media (max-width: 920px) {
  .Footer_Footer__QazpK .Footer_media1__v5PH0 {
    margin-bottom: 7px;
    order: 1;
  }
}
.Footer_Footer__QazpK .Footer_media1__v5PH0 img {
  width: 20px;
  margin-left: 5px;
}
.Footer_Footer__QazpK .Footer_media1__v5PH0 a {
  padding: 0 7px;
  color: rgba(255, 255, 255, 0.63);
  font-family: "hemi_head";
  display: flex;
  align-items: center;
}
@media (max-width: 400px) {
  .Footer_Footer__QazpK .Footer_media1__v5PH0 a {
    padding: 0px 5px;
  }
}
.Footer_Footer__QazpK .Footer_media__-4Q9J {
  display: flex;
  list-style: none;
  margin: 0 auto;
  padding: 0;
  margin-bottom: 5px;
  width: 80%;
}
@media (max-width: 1386px) {
  .Footer_Footer__QazpK .Footer_media__-4Q9J {
    width: 95%;
  }
}
@media (max-width: 920px) {
  .Footer_Footer__QazpK .Footer_media__-4Q9J {
    margin-bottom: 7px;
    order: 1;
    justify-content: center;
  }
}
.Footer_Footer__QazpK .Footer_media__-4Q9J img {
  width: 40px;
  margin-left: 5px;
}
.Footer_Footer__QazpK .Footer_media__-4Q9J a {
  color: rgba(255, 255, 255, 0.63);
  font-family: "hemi_head";
  display: flex;
  align-items: center;
}
.Footer_Footer__QazpK .Footer_logo_svg__VnRKO {
  margin-right: -50px;
  margin-top: -15px;
}
@media (max-width: 790px) {
  .Footer_Footer__QazpK .Footer_logo_svg__VnRKO {
    margin-right: 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.module.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;EACA,kDAAA;EACA,eAAA;AAAJ;AACI;EARF;IASI,UAAA;EAEJ;AACF;AADI;EAXF;IAYG,iBAAA;EAIH;AACF;AAHI;EAdF;IAeG,8BAAA;EAMH;AACF;AAJM;EADF;IAEI,WAAA;IACA,kBAAA;EAON;AACF;AAJI;EACE,aAAA;AAMN;AAJM;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAMR;AAFI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAIN;AAFM;EACE,YAAA;EACA,aAAA;AAIR;AAFQ;EACE,kBAAA;EACA,WAAA;AAIV;AAAM;EACE,gCAAA;EACA,eAAA;AAER;AADQ;EAHF;IAII,eAAA;EAIR;AACF;AACE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACJ;AAAI;EARF;IASI,UAAA;EAGJ;AACF;AAFI;EAXF;IAYI,8BAAA;IACA,kBAAA;EAKJ;AACF;AAHI;EAhBF;IAiBI,uBAAA;EAMJ;AACF;AAJI;EACE,aAAA;AAMN;AADM;EACE,gCAAA;EACA,wBAAA;AAGR;AAFQ;EAHF;IAII,eAAA;EAKR;AACF;AAJQ;EANF;IAOI,eAAA;EAOR;AACF;AALQ;EACE,sBAAA;AAOV;AAHM;EACE,cAAA;EACA,gCAAA;EACA,gBAAA;AAKR;AAJQ;EAJF;IAKI,eAAA;IACA,cAAA;EAOR;AACF;AAHI;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAKN;AAJM;EALF;IAMI,kBAAA;IACA,QAAA;EAON;AACF;AANM;EACE,WAAA;EACA,gBAAA;AAQR;AALM;EAEE,gCAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;AAMR;AACE;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AACJ;AAAI;EAPF;IAQI,kBAAA;IACA,QAAA;EAGJ;AACF;AAFI;EACE,WAAA;EACA,gBAAA;AAIN;AADI;EACE,cAAA;EACA,gCAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;AAGN;AAFM;EANF;IAOE,gBAAA;EAKJ;AACF;AAFE;EACE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AAIJ;AAHI;EAPF;IAQG,UAAA;EAMH;AACF;AALI;EAVF;IAWI,kBAAA;IACA,QAAA;IACA,uBAAA;EAQJ;AACF;AAPI;EACE,WAAA;EACA,gBAAA;AASN;AANI;EAEE,gCAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;AAON;AAAE;EACE,mBAAA;EACA,iBAAA;AAEJ;AADI;EAHF;IAII,iBAAA;EAIJ;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');\n\n.Footer {\n  font-family: 'Roboto';\n\n  .content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 80%;\n    margin: 30px auto;\n    border-bottom: 2px solid rgba(217, 217, 217, 0.45);\n    flex-wrap: wrap;\n    @media (max-width: 1386px) {\n      width: 95%;\n    }\n    @media (max-width: 920px) {\n     margin: 15px auto;\n    }\n    @media (max-width: 780px) {\n     flex-direction: column-reverse;\n    }\n    div {\n      @media (max-width: 790px) {\n        width: 100%;\n        text-align: center;\n      }\n    }\n\n    .links {\n      display: flex;\n\n      ul {\n        display: flex;\n        flex-direction: column;\n        margin-left: 30px;\n      }\n    }\n\n    ul {\n      display: flex;\n      flex-direction: column;\n      list-style: none;\n      margin: 0;\n      padding: 0;\n\n      li {\n        padding: 4px;\n        display: flex;\n\n        svg {\n          margin-right: 10px;\n          width: 23px;\n        }\n      }\n\n      a {\n        color: rgba(255, 255, 255, 0.63);\n        font-size: 18px;\n        @media (max-width: 640px) {\n          font-size: 15px;\n        }\n      }\n    }\n  }\n\n  .c_right {\n    width: 80%;\n    margin: auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 5px;\n    flex-wrap: wrap;\n    @media (max-width: 1386px) {\n      width: 95%;\n    }\n    @media (max-width: 920px) {\n      flex-direction: column-reverse;\n      margin-bottom: 5px;\n    }\n\n    @media (max-width: 640px) {\n      justify-content: center;\n    }\n\n    div {\n      display: flex;\n      @media (max-width: 640px) {\n        //padding-bottom: 10px;\n      }\n\n      a {\n        color: rgba(255, 255, 255, 0.63);\n        font-family: \"hemi_head\";\n        @media (max-width: 640px) {\n          font-size: 14px;\n        }\n        @media (max-width: 368px) {\n          font-size: 12px;\n        }\n\n        svg {\n          vertical-align: bottom;\n        }\n      }\n\n      li {\n        padding: 0 7px;\n        color: rgba(255, 255, 255, 0.63);\n        list-style: none;\n        @media (max-width: 640px) {\n          font-size: 14px;\n          padding: 0 5px;\n        }\n      }\n    }\n\n    .media {\n      display: flex;\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      @media (max-width: 920px) {\n        margin-bottom: 7px;\n        order: 1;\n      }\n      img {\n        width: 40px;\n        margin-left: 5px;\n      }\n\n      a {\n        //padding: 0 7px;\n        color: rgba(255, 255, 255, 0.63);\n        font-family: \"hemi_head\";\n        display: flex;\n        align-items: center;\n        //@media (max-width: 400px) {\n        //padding: 0px 5px;\n        //}\n      }\n    }\n  }\n  .media1 {\n    display: flex;\n    list-style: none;\n    justify-content: center;\n    align-items: end;\n    margin: 0;\n    padding: 0;\n    @media (max-width: 920px) {\n      margin-bottom: 7px;\n      order: 1;\n    }\n    img {\n      width: 20px;\n      margin-left: 5px;\n    }\n\n    a {\n      padding: 0 7px;\n      color: rgba(255, 255, 255, 0.63);\n      font-family: \"hemi_head\";\n      display: flex;\n      align-items: center;\n      @media (max-width: 400px) {\n      padding: 0px 5px;\n      }\n    }\n  }\n  .media {\n    display: flex;\n    list-style: none;\n    margin: 0 auto;\n    padding: 0;\n    margin-bottom: 5px;\n    width: 80%;\n    @media (max-width: 1386px) {\n     width: 95%;\n    }\n    @media (max-width: 920px) {\n      margin-bottom: 7px;\n      order: 1;\n      justify-content: center;\n    }\n    img {\n      width: 40px;\n      margin-left: 5px;\n    }\n\n    a {\n      //padding: 0 7px;\n      color: rgba(255, 255, 255, 0.63);\n      font-family: \"hemi_head\";\n      display: flex;\n      align-items: center;\n      //@media (max-width: 400px) {\n      //padding: 0px 5px;\n      //}\n    }\n  }\n\n  .logo_svg{\n    margin-right: -50px;\n    margin-top: -15px;\n    @media (max-width: 790px) {\n      margin-right: 0px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Footer": `Footer_Footer__QazpK`,
	"content": `Footer_content__eSS1G`,
	"links": `Footer_links__MvOVh`,
	"c_right": `Footer_c_right__OrmYR`,
	"media": `Footer_media__-4Q9J`,
	"media1": `Footer_media1__v5PH0`,
	"logo_svg": `Footer_logo_svg__VnRKO`
};
export default ___CSS_LOADER_EXPORT___;
